import { render, staticRenderFns } from "./Expiry_date.vue?vue&type=template&id=73ba87f3&"
import script from "./Expiry_date.vue?vue&type=script&lang=js&"
export * from "./Expiry_date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports